import workspaceQuery from '../../queries/product/AutomaticDispatchResultWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const AutomaticDispatchResult: EntityType = {
  type: 'AutomaticDispatchResult',
  title: 'Automatic Dispatch Results',
  workspaceUrl: '/Products/AutomaticDispatchResults/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'DISPATCH_INSTRUCTIONS',
};

export default AutomaticDispatchResult;
